import { FilterObject } from './filter-object';
import * as lodash from 'lodash';

export class MatchTypeFilter extends FilterObject<any> {

  public filter(itemToFiltre: any): boolean {
    return this.doFilter(itemToFiltre, this.field, this.values);
  }

  public doFilter(itemToFiltre: any, field: any, value: any): boolean {
    if (value == null) {
      return true;
    }
    let result = false;
    if (itemToFiltre[field]) {
      let comp = itemToFiltre[field];
      comp = lodash.deburr(comp);
      comp = lodash.lowerCase(comp);

      value = lodash.deburr(value);
      value = lodash.lowerCase(value);

      result = result || comp == value;
      if (result) {
        console.log(result);
      }
    }
    return result;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/filter/filters/match-type.filter.ts